import React from "react";
import TermsContent from "../../components/terms/TermsContent";
import Seo from "../../shared/seo/Seo";
import { urls, copy, currentLang } from "../../shared/seo/links";

export default function Terms() {
  return (
    <>
      <Seo
        title={copy.page(currentLang(), "terms").title}
        description={copy.page(currentLang(), "terms").description}
        path={urls.sectionPath("terms", currentLang())}
        alternates={urls.alternates((l) => urls.sectionPath("terms", l))}
      />
      <TermsContent />
    </>
  );
}
